// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"DroppableDiv_mainContainer__3KcK-","dragover":"DroppableDiv_dragover__18tUi","illegalDrag":"DroppableDiv_illegalDrag__1WvQ0"};